// الرسائل المجدولة (30-أكتوبر-2026): بطاقة العقار مع الرسائل التي تُرسل تلقائيًا
// لكل حجز. اللوحة: components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "الرسائل المجدولة",
    sub: "ما يصل إلى الضيف، من لحظة الحجز حتى بعد المغادرة.",
    new: "رسالة جديدة",
  },
  loadError: "تعذّر تحميل الرسائل.",
  retry: "إعادة المحاولة",
  cancel: "إلغاء",
  noName: "بدون اسم",
  tabs: { mensajes: "الرسائل", proximos: "الإرسالات القادمة", historial: "السجل" },
  stages: { antes: "قبل الوصول", durante: "أثناء الإقامة", despues: "بعد المغادرة" },
  when: {
    entrada: "تسجيل الوصول",
    salida: "المغادرة",
    sameDay: "يوم {momento}، عند الساعة {hora}",
    before: "قبل {momento} بـ {n} يوم، عند الساعة {hora} | قبل {momento} بـ {n} أيام، عند الساعة {hora}",
    after: "بعد {momento} بـ {n} يوم، عند الساعة {hora} | بعد {momento} بـ {n} أيام، عند الساعة {hora}",
  },
  channels: { email: "البريد الإلكتروني", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "الكل", directa: "مباشرة", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "قنوات أخرى" },
  status: {
    pendiente: "قيد التنفيذ",
    enviado: "تم الإرسال",
    en_cola: "بانتظار القبول",
    fallo: "لم تُرسل",
    sin_contacto: "لا توجد بيانات اتصال",
    cancelado: "ملغاة",
  },
  errors: {
    canal_reserva_no_encontrada: "لم تعثر القناة على هذا الحجز. ربما لم يعد موجودًا أو أن محادثته غير متاحة.",
    canal_sin_permiso: "لم تصرّح القناة بالإرسال. تحقق من اتصال مكان الإقامة هذا.",
    canal_no_responde: "لم تستجب القناة في ذلك الوقت.",
    canal_rechazo: "لم تقبل القناة الرسالة.",
    whatsapp_numero_invalido: "الرقم غير صالح أو لا يستخدم واتساب.",
    whatsapp_rechazo: "لم يقبل واتساب الرسالة.",
    correo_fallido: "تعذر تسليم البريد الإلكتروني.",
    envio_fallido: "تعذر إتمام الإرسال.",
    envio_interrumpido: "توقف الإرسال قبل اكتماله.",
    sin_telefono: "لا يحتوي الحجز على رقم هاتف صالح.",
    sin_correo: "لا يحتوي الحجز على بريد خاص به. بريد منصات الحجز هو اسم مستعار.",
    sin_chat_ota: "لا يأتي الحجز من منصة حجز بها محادثة.",
    mensaje_borrado: "حُذفت الرسالة قبل إرسالها.",
    mensaje_desactivado: "عُطلت الرسالة قبل إرسالها.",
    reserva_cancelada: "أُلغي الحجز قبل الإرسال.",
    alojamiento_no_existe: "لم يعد مكان الإقامة موجودًا.",
    mensaje_vacio: "أصبحت الرسالة فارغة.",
    ya_no_tocaba: "عندما وافق الضيف، لم يعد التسليم مناسبًا.",
  },
  unitScope: {
    sub: "لـ {name} فقط. تصلها رسائل الإعلان أيضًا ما لم تغيّرها أو توقفها هنا.",
    inherited: "من الإعلان",
    replaces: "تحل محل رسالة الإعلان",
    removed: "متوقفة في هذه الوحدة",
    offInListing: "متوقفة في الإعلان",
    differentIn: "مختلفة في: {names}",
    customize: "التغيير لهذه الوحدة فقط",
    turnOff: "عدم إرسال «{name}» في هذه الوحدة",
    confirmRestore: "هل تريد الحذف؟ ستعود رسالة الإعلان للإرسال.",
    ownUnits: "لهذه الوحدات رسائلها الخاصة أيضًا: {names}. يتم تعديلها من كل وحدة.",
    replaceHint: "الاسم نفسه لرسالة في الإعلان: سيتم إرسال هذه بدلًا منها في هذه الوحدة.",
  },
  clone: {
    button: "استنساخ",
    rowAction: "استنساخ إلى عقار أو وحدة أخرى",
    titleAll: "استنساخ إلى عقارات أو وحدات أخرى",
    bring: "جلب من مكان آخر",
    bringTitle: "جلب الرسائل من عقار أو وحدة أخرى",
    bringNoun: "رسائله المجدولة",
    titleOne: "استنساخ «{name}»",
    subtitle: "يتم نسخ النص والقنوات وعوامل التصفية والملفات. إذا وُجدت هناك رسالة بالاسم نفسه فسيتم تحديثها، ولن تتغير الرسائل الأخرى. ستبدأ الرسائل النشطة بالإرسال حسب التوقيت المحلي لكل عقار.",
    nounAll: "الرسالة المجدولة | الرسائل المجدولة ({n})",
    nounOne: "الرسالة «{name}»",
    done: "تم النسخ إلى {n} مكان إقامة: {nuevos} جديدة و{actualizados} محدّثة. | تم النسخ إلى {n} أماكن إقامة: {nuevos} جديدة و{actualizados} محدّثة.",
    skipped: {
      limite: "{names}: وصل إلى الحد الأقصى من الرسائل ولم تتسع «{msgs}».",
      archivo: "{names}: يوجد ملف مفقود من «{msgs}». ارفعه هنا مرة أخرى ثم أعد الاستنساخ.",
      error: "{names}: تعذّر نسخ «{msgs}».",
    },
  },
  timeline: {
    booked: "تم تأكيد الحجز",
    bookedHint: "إذا تم الحجز بعد فوات الموعد، فلن تُرسل هذه الرسالة.",
    checkin: "يوم الوصول",
    checkout: "يوم المغادرة",
    use: "استخدام",
    add: "+ إضافة رسالة هنا",
    offset: {
      sameDay: "في ذلك اليوم",
      before: "قبل {n} يوم | قبل {n} أيام",
      afterCheckin: "بعد {n} يوم | بعد {n} أيام",
      beforeCheckout: "قبل المغادرة بـ {n} يوم | قبل المغادرة بـ {n} أيام",
      after: "بعد {n} يوم | بعد {n} أيام",
    },
  },
  presets: {
    week: { name: "بقي أسبوع", text: "مرحبًا {nombre}، اقترب موعد إقامتك في {alojamiento}. نحن بانتظارك في {entrada}. إذا احتجت إلى أي شيء قبل وصولك، راسلنا." },
    three: { name: "استعد لوصولك", text: "مرحبًا {nombre}، بعد 3 أيام نستقبلك في {alojamiento}. تسجيل الوصول يبدأ من الساعة {hora_entrada}. هنا كل ما يخص إقامتك: {enlace_portal}" },
    arrival: { name: "اليوم موعد وصولك", text: "مرحبًا {nombre}، نحن بانتظارك اليوم في {alojamiento} ابتداءً من الساعة {hora_entrada}. رحلة سعيدة!" },
    firstNight: { name: "الليلة الأولى", text: "مرحبًا {nombre}، نتمنى أن تكون قد استقررت في {alojamiento}. هل كل شيء على ما يرام؟ إذا احتجت إلى أي شيء، أجب على هذه الرسالة." },
    lastDay: { name: "يوم المغادرة", text: "مرحبًا {nombre}، تنتهي اليوم إقامتك في {alojamiento}. نذكّرك بأن موعد المغادرة حتى الساعة {hora_salida}. شكرًا لإقامتك معنا." },
    after: { name: "شكرًا لزيارتك", text: "مرحبًا {nombre}، شكرًا لإقامتك في {alojamiento}. نأمل أن نراك قريبًا." },
  },
  row: {
    files: "{n} ملف | {n} ملفات",
    sent: "{n} مُرسلة | {n} مُرسلة",
    queued: "{n} بالانتظار",
    failed: "{n} لم تُرسل",
    duplicate: "تكرار",
    delete: "حذف",
    confirmDelete: "هل تريد حذف هذه الرسالة؟",
    yesDelete: "نعم، احذف",
    copyOf: "نسخة من {name}",
  },
  upcoming: {
    arrives: "الوصول {fecha}",
    leaves: "المغادرة {fecha}",
    note: "ما سيُرسل خلال الأيام الثلاثين القادمة مع حجوزات اليوم. مشطوب: لا يمكن الوصول إلى هذا الحجز عبر هذه القناة.",
    empty: "لا توجد إرسالات مقررة خلال الأيام الثلاثين القادمة.",
    when: "متى",
    guest: "النزيل",
    message: "الرسالة",
    channels: "القنوات",
    needsCheckin: "فقط إذا أكمل تسجيل الوصول",
    noReach: "لا توجد بيانات لهذه القناة",
  },
  history: {
    empty: "لم تُرسل أي رسالة بعد.",
    when: "التاريخ",
    result: "النتيجة",
    prev: "السابق",
    next: "التالي",
  },
  vars: {
    nombre: "الاسم",
    alojamiento: "مكان الإقامة",
    entrada: "تاريخ الوصول",
    salida: "تاريخ المغادرة",
    hora_entrada: "ساعة الوصول",
    hora_salida: "ساعة المغادرة",
    codigo: "رمز الحجز",
    enlace_portal: "رابط البوابة",
    enlace_tienda: "رابط المتجر",
  },
  form: {
    newTitle: "رسالة جديدة",
    editTitle: "تعديل الرسالة",
    name: "الاسم الداخلي",
    namePh: "مثال: استعد لوصولك",
    when: "موعد الإرسال",
    type: { antes: "قبل", dia: "في نفس يوم", despues: "بعد" },
    days: "الأيام",
    reference: "المرجع",
    theDayOf: "يوم",
    anchor: { entrada: "تسجيل الوصول", salida: "المغادرة" },
    time: "الساعة",
    timeIn: "بتوقيت {zone}",
    timeEach: "بالتوقيت المحلي لكل مكان إقامة: {zones}",
    noZone: "{names}: بدون تحديد البلد لا نعرف التوقيت، لذا لن تُرسل الرسائل هناك. حدده في موقع مكان الإقامة.",
    localTime: "توقيت مكان الإقامة",
    duringHint: "إذا كانت الإقامة أقصر ولم يعد النزيل موجودًا في ذلك اليوم، لا تُرسل الرسالة.",
    channels: "عبر أي قناة تُرسل",
    channelShort: { email: "البريد الخاص فقط", whatsapp: "قالب بعد 24 ساعة", ota: "محادثة الحجز" },
    previewShort: "معاينة",
    previewFrom: "رسالة من",
    channelHint: {
      email: "فقط للحجوزات التي لها بريد إلكتروني خاص. البريد الذي تقدمه OTA هو اسم مستعار، لذا لا يصل إليه شيء.",
      whatsapp: "إذا مرّت أكثر من 24 ساعة أو لا توجد محادثة، نرسل قالب التواصل وتصل الرسالة إلى النزيل عند قبوله. مع رقم وهمي لا يُرسل شيء.",
      ota: "عبر دردشة OTA، فقط للحجوزات من هذه القناة. تُرسل الملفات كرابط.",
    },
    bookings: "لأي الحجوزات",
    onlyCheckin: "فقط إذا أكمل تسجيل الوصول مسبقًا",
    message: "الرسالة",
    messagePh: "اكتب الرسالة التي سيتلقاها النزيل",
    translate: "الترجمة إلى اللغات الأخرى",
    translating: "جارٍ الترجمة…",
    translated: "تمت الترجمة إلى اللغات الأخرى.",
    translatePartial: "تعذّرت ترجمة {n} لغات. يرجى مراجعتها.",
    storeHint: "يتطلب المتجر الداخلي إتمام تسجيل الوصول؛ وحتى ذلك الحين يقود الرابط إلى بوابة الضيف ومنها إلى المتجر. أما المتجر الخارجي فيفتح مباشرة.",
    fallbackHint: "تُرسل بلغة النزيل. إذا لم تُكتب بتلك اللغة، تُرسل بالإسبانية أو بأول لغة متاحة.",
    subject: "موضوع البريد الإلكتروني (اختياري)",
    subjectPh: "إذا تُرك فارغًا: رسالة من مكان إقامتك",
    files: "صور وفيديوهات ومستندات",
    addFile: "إضافة ملف",
    uploading: "جارٍ الرفع…",
    filesHint: "صور JPG أو PNG حتى {img} ميغابايت، وPDF حتى {pdf} ميغابايت، وXML حتى {xml} ميغابايت، وفيديو MP4 أو 3GP (H.264) حتى {video} ميغابايت. لا يقبل واتساب ملفات XML، لذا يُرسل هناك كرابط. وفي البريد الإلكتروني يُرفق كملف.",
    fileTooBig: "«{name}» يتجاوز الحد الأقصى {max} ميغابايت.",
    uploadError: "تعذّر رفع الملف.",
    active: "مفعّلة",
    inactive: "معطّلة",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    saved: "تم حفظ الرسالة.",
    saveError: "تعذّر الحفظ. حاول مرة أخرى.",
    errName: "أعطِ الرسالة اسمًا.",
    errChannels: "اختر قناة إرسال واحدة على الأقل.",
    errTime: "حدّد ساعة الإرسال.",
    errText: "اكتب الرسالة بلغة واحدة على الأقل.",
    preview: "معاينة ببيانات تجريبية",
    previewEmpty: "ستظهر الرسالة هنا.",
  },
};
